module.exports = __webpack_public_path__ + "img/full6-min.8487f37e.png";